import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { IDynamicTableColumn } from '@app/shared/interfaces/dynamic-table.interface';
import { IPagination } from '@app/shared/interfaces/mainTable.interface';
import { StockyEntryService } from '../../services/stocky-entry.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-batch-delivery',
  templateUrl: './batch-delivery.component.html',
  styleUrls: ['./batch-delivery.component.sass'],
})
export class BatchDeliveryComponent implements OnInit {
  constructor(
    private stockyEntryService: StockyEntryService,
    private _toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    const auth = JSON.parse(sessionStorage.getItem('auth') || '{}');

    if (auth?.name) {
      const names = auth.name.trim().split(' ');

      this.userName = names.slice(0, 2).join(' ');
    }

    this.getLots();
  }

  userName: string = '';

  lots: any[] = [];

  selectedLots: any[] = [];

  lotSearch = '';

  tableData: any[] = [];
  displayedColumns: string[] = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  actionColumn!: IDynamicTableColumn;

  serverPagination: IPagination | undefined;

  pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  };

  tableColumns: IDynamicTableColumn[] = [
    {
      columnDef: 'numero',
      header: 'Lote',
    },
    {
      columnDef: 'quantidade',
      header: 'Quantidade',
    },
    {
      columnDef: 'dataFechamento',
      header: 'Fechamento',
    },
    {
      columnDef: 'tools',
      header: 'Ações',
      actions: [
        {
          name: 'remove',
          text: 'Remover',
          icon: 'delete_forever',
          color: 'warn',
          type: 'stroked',
        },
      ],
    },
  ];

  get filteredLots(): any[] {
    const searchTerm = this.lotSearch.trim();

    if (!searchTerm) {
      return this.lots;
    }

    return this.lots.filter((lot) => String(lot.numero).includes(searchTerm));
  }

  addLots(): void {
    const mappedLots = this.selectedLots
      .filter((lot) => !this.tableData.some((item) => item.id === lot.id))
      .map((lot) => ({
        id: lot.id,
        numero: lot.numero,
        quantidade: `${lot.quantidade} unidades`,
        dataFechamento: lot.dataFechamento,
      }));

    this.tableData = [...this.tableData, ...mappedLots];

    this.pagination.totalItems = this.tableData.length;

    this.selectedLots = [];
    this.lotSearch = '';
  }

  handleAction(event: any): void {
    if (event.action === 'remove') {
      this.removeLot(event.row);
    }
  }

  removeLot(row: any): void {
    this.tableData = this.tableData.filter((item) => item.id !== row.id);

    this.pagination.totalItems = this.tableData.length;
  }

  onPageChange(event: any): void {
    this.pagination.currentPage = event.currentPage;
    this.pagination.pageSize = event.pageSize;
    this.getLots();
  }

  batchDelivery(): void {
    const payload = {
      loteIds: this.tableData.map((lot) => lot.id),
      loginResponsavel: this.userName,
    };
    this.stockyEntryService.batchDelivery(payload).subscribe({
      next: () => {
        this._toastrService.success(
          'Os lotes selecionados foram disponibilizados para carregamento com sucesso.'
        );
        this.selectedLots = [];
        this.tableData = [];
        this.getLots();
      },
      error: (err) => {
        this._toastrService.error(err.errors[0] ?? 'Erro ao realizar a entrega em lote.');
      },
    });
  }

  removeSelectedLot(lotToRemove: any): void {
    this.selectedLots = this.selectedLots.filter((lot) => lot.id !== lotToRemove.id);
  }

  getLots(): void {
    const params = {
      Page: this.pagination.currentPage,
      PageSize: this.pagination.pageSize,
    };
    this.stockyEntryService.getLotsClosed(params).subscribe({
      next: (response) => {
        const lots = response ?? [];

        this.lots = lots.map((lot: any) => ({
          id: lot.id,
          numero: lot.numero,
          quantidade: lot.quantidade,
          dataFechamento: this.formatDate(lot.dataFechamento),
        }));
      },
      error: (err) => {
        this._toastrService.error(err?.errors[0] ?? 'Erro ao carregar os lotes fechados.');
      },
    });
  }

  formatDate(date: string): string {
    if (!date) {
      return '-';
    }

    const formattedDate = new Date(date);

    return formattedDate.toLocaleString('pt-BR');
  }
}
